module.exports = __webpack_public_path__ + "static/media/long-arrow-left.b123c762.svg";